module.exports = __webpack_public_path__ + "static/Profile_Annika-5d015968607f6c1c2f2a210381418ed9.jpg";